module.exports = __webpack_public_path__ + "static/icons/icon-information-girl.a227e12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-information-girl.svg
// module id = 2fag
// module chunks = 1